function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#70B2CE;stroke-width:12;stroke-linecap:round;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:none;stroke:#E2007A;stroke-width:5;}\n\t.st3{fill:none;stroke:#70B2CE;stroke-width:7.425;stroke-linecap:round;}\n\t.st4{clip-path:url(#SVGID_6_);}\n\t.st5{fill:#006F9F;}\n\t.st6{fill:none;stroke:#000000;}\n\t.st7{fill:#70B2CE;}\n\t.st8{fill:none;stroke:#70B2CE;stroke-width:7.425;}\n\t.st9{fill:#A5A5A5;}\n\t.st10{fill:none;stroke:#E66425;stroke-width:7;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st11{clip-path:url(#SVGID_10_);fill:#E66425;}\n\t.st12{fill:#245B99;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M215.2,53.9c-1,0-2-0.4-2.7-1.2l-10.4-10.9c-1.4-1.5-1.4-3.8,0.1-5.2c1.5-1.4,3.8-1.4,5.2,0.1l10.4,10.9 c1.4,1.5,1.4,3.8-0.1,5.2C217.1,53.6,216.1,53.9,215.2,53.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4,10.7l14.3,35.2h-9.5l-2.3-5.8H13.6l-2.2,5.8H1.8l14.3-35.2H26.4z M21.2,19.3L16,32.7h10.4L21.2,19.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M50.2,45.9L36,10.7h9.6l9.9,26l9.9-26h9.5L60.5,45.9H50.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M86.7,45.9V18.1h-10v-7.4h28.5v7.4h-10v27.8H86.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M106.9,28.3c0-10.6,7.7-18.4,18.9-18.4c11.1,0,18.9,7.7,18.9,18.4c0,10.6-7.8,18.4-18.9,18.4 C114.6,46.7,106.9,38.9,106.9,28.3z M136.1,28.3c0-6.2-4-10.9-10.3-10.9s-10.3,4.7-10.3,10.9c0,6.1,4,10.9,10.3,10.9 S136.1,34.5,136.1,28.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M149.7,45.9V10.7h8.4v27.8h15.5v7.4H149.7z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M175.6,28.3c0-10.6,7.7-18.4,18.9-18.4c11.1,0,18.9,7.7,18.9,18.4c0,10.6-7.8,18.4-18.9,18.4 C183.3,46.7,175.6,38.9,175.6,28.3z M204.8,28.3c0-6.2-4-10.9-10.3-10.9s-10.3,4.7-10.3,10.9c0,6.1,4,10.9,10.3,10.9 S204.8,34.5,204.8,28.3z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M216.8,28.3c0-11.1,8.4-18.4,19.3-18.4c6.9,0,11.9,3.5,14.7,7.6l-6.8,4c-1.7-2.3-4.4-4-7.8-4c-6.3,0-10.7,4.5-10.7,10.9 c0,6.3,4.4,10.9,10.7,10.9c3.1,0,5.5-1.3,6.9-2.5v-3.7h-8.4v-7h16.8V40c-3.8,4.1-9.1,6.7-15.4,6.7C225.2,46.7,216.8,39.4,216.8,28.3 z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M188.5,21.9l14.4,6.7c0,0,0-0.1,0-0.1c0-5.1-3.8-9.2-8.4-9.2C192.2,19.2,190.1,20.2,188.5,21.9z"
});

var _ref12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M26.4,10.7l14.3,35.2h-9.5l-2.3-5.8H13.6l-2.2,5.8H1.8l14.3-35.2H26.4z M21.2,19.3L16,32.7h10.4L21.2,19.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M50.2,45.9L36,10.7h9.6l9.9,26l9.9-26h9.5L60.5,45.9H50.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M86.7,45.9V18.1h-10v-7.4h28.5v7.4h-10v27.8H86.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M106.9,28.3c0-10.6,7.7-18.4,18.9-18.4c11.1,0,18.9,7.7,18.9,18.4c0,10.6-7.8,18.4-18.9,18.4 C114.6,46.7,106.9,38.9,106.9,28.3z M136.1,28.3c0-6.2-4-10.9-10.3-10.9s-10.3,4.7-10.3,10.9c0,6.1,4,10.9,10.3,10.9 S136.1,34.5,136.1,28.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M149.7,45.9V10.7h8.4v27.8h15.5v7.4H149.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M216.8,28.3c0-11.1,8.4-18.4,19.3-18.4c6.9,0,11.9,3.5,14.7,7.6l-6.8,4c-1.7-2.3-4.4-4-7.8-4 c-6.3,0-10.7,4.5-10.7,10.9c0,6.3,4.4,10.9,10.7,10.9c3.1,0,5.5-1.3,6.9-2.5v-3.7h-8.4v-7h16.8V40c-3.8,4.1-9.1,6.7-15.4,6.7 C225.2,46.7,216.8,39.4,216.8,28.3z"
}));

var SvgAvtologLogoNov202003030404 = function SvgAvtologLogoNov202003030404(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 253.2 56.7",
    style: {
      enableBackground: "new 0 0 253.2 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAvtologLogoNov202003030404, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avtolog_logo_nov_2020-03-03-04-04.5b24f15c.svg";
export { ForwardRef as ReactComponent };